import type { TrackFunction } from "@similarweb/contact-us";

import type {
    OnboardingFocusQuestionType,
    OnboardingGoalQuestionType,
} from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import type { OnboardingWizardActiveFocusItems } from "app/pages/sales-intelligence/sub-modules/onboarding/types/OnboardingWizardAnswer.dto";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

const FIRST_QUESTION = "What is your primary focus?";
const FIRST_QUESTION_NUMBER = 1;
const SECOND_QUESTION = "How would you like to start?";
const SECOND_QUESTION_NUMBER = 2;

export default function createOnboardingWizardTrackingService(track: TrackFunction) {
    function trackWizardClickEvent(eventName: string, eventSubName?: string, eventSubSubName?: string | number): void {
        const event: string = createTrackingEventName(eventName, eventSubName, eventSubSubName);

        track("onboarding wizard", "click", event);
    }

    function trackWizardClickNext(eventSubName: string, eventSubSubName: string | number): void {
        track("onboarding wizard", "click", `click next/${eventSubName}/${eventSubSubName}`);
    }

    return {
        // question step 1
        trackClickOnFocusOption(optionName: OnboardingFocusQuestionType) {
            trackWizardClickEvent(optionName, FIRST_QUESTION, FIRST_QUESTION_NUMBER);
        },
        trackClickNextOnFocusQuestions(selectedOptions: (keyof OnboardingWizardActiveFocusItems)[]) {
            trackWizardClickNext(FIRST_QUESTION, selectedOptions.join(","));
        },
        // question step 2
        trackClickOnGoalOption(optionName: OnboardingGoalQuestionType) {
            trackWizardClickEvent(optionName, SECOND_QUESTION, SECOND_QUESTION_NUMBER);
        },
        trackClickNextOnGoalQuestions(optionName: OnboardingGoalQuestionType) {
            trackWizardClickNext(SECOND_QUESTION, optionName);
        },

        trackClickBack() {
            trackWizardClickEvent("click back");
        },
        trackClickOnSkip() {
            trackWizardClickEvent("take me to the platform");
        },
    };
}
